import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5275a020"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center flex-col items-center" }

import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { SankeyChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent } from 'echarts/components';
import VChart from 'vue-echarts';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SankeyDiagram',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;
const sankeyColors = ['#fc9f9d', '#d0999f', '#b295a2', '#8f90a5'];
const sankeyLineStyle = {
	color: 'gradient',
	opacity: 0.6,
};
const sankeyLevels = [
	{
		depth: 0,
		itemStyle: {
			color: sankeyColors[0],
		},
		lineStyle: sankeyLineStyle,
	},
	{
		depth: 1,
		itemStyle: {
			color: sankeyColors[1],
		},
		lineStyle: sankeyLineStyle,
	},
	{
		depth: 2,
		itemStyle: {
			color: sankeyColors[2],
		},
		lineStyle: sankeyLineStyle,
	},
	{
		depth: 3,
		itemStyle: {
			color: sankeyColors[3],
		},
		lineStyle: sankeyLineStyle,
	},
];

use([CanvasRenderer, SankeyChart, TitleComponent, TooltipComponent]);

const option = ref({
	title: {
		text: props.data.title,
	},
	tooltip: {
		trigger: 'item',
		triggerOn: 'mousemove',
	},
	series: [
		{
			type: 'sankey',
			data: props.data.nodes,
			links: props.data.links,
			label: {
				color: '#000',
				overflow: 'truncate',
				ellipsis: '...',
				width: 150,
				hideOverlap: true,
			},
			emphasis: {
				focus: 'adjacency',
			},
			levels: sankeyLevels,
			lineStyle: {
				curveness: 0.5,
			},
			top: '10%',
			bottom: '15px',
			right: '150px',
			left: 0,
		},
	],
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.data.nodes && props.data.links)
      ? (_openBlock(), _createBlock(_unref(VChart), {
          key: 0,
          class: "chart",
          option: option.value,
          autoresize: "",
          "init-options": { width: 800, height: 320 }
        }, null, 8, ["option"]))
      : _createCommentVNode("", true)
  ]))
}
}

})